import { Box, CircularProgress, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import Checkout from 'components/Checkout';
import {
  selectCurrentSong,
  selectInitialSong,
} from 'services/store/remixer/selectors';
import ErrorDialog from './components/ErrorDialog';
import Header from './components/Header';
import Info from './components/Info';
import {
  EffectsPanel,
  FormulaEditor,
  Player,
} from './components/Playback/components';
import AudioProvider from './AudioProvider';
import {
  EffectsPanelCell,
  FormulaEditorCell,
  InfoCell,
  PlayerCell,
  StudioGrid,
  StudioGridCell,
  StudioLayout,
} from './styled';

const Remixer = () => {
  const theme = useTheme();

  const initialSong = useSelector(selectInitialSong);

  const currentSong = useSelector(selectCurrentSong);
  const song = currentSong?.data ?? null;

  if (!initialSong || initialSong.loading) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress color="primary" size={theme.spacing(8)} />
      </Box>
    );
  }

  if (initialSong.error) {
    return <Box>request track error</Box>;
  }

  return (
    <StudioLayout>
      <AudioProvider>
        <Header />
        <StudioGrid>
          <InfoCell>
            <StudioGridCell>
              <Info />
            </StudioGridCell>
          </InfoCell>
          <FormulaEditorCell>
            <FormulaEditor />
          </FormulaEditorCell>
          <PlayerCell>
            <Player song={song} />
          </PlayerCell>
          <EffectsPanelCell>
            <EffectsPanel />
          </EffectsPanelCell>
        </StudioGrid>
      </AudioProvider>
      <ErrorDialog />
      <Checkout shouldBlockRedirect />
    </StudioLayout>
  );
};

export default Remixer;
